import { render } from "./MaskContainer.vue?vue&type=template&id=1a6227f8&ts=true"
import script from "./MaskContainer.vue?vue&type=script&lang=ts"
export * from "./MaskContainer.vue?vue&type=script&lang=ts"

import "./MaskContainer.vue?vue&type=style&index=0&id=1a6227f8&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__